<template>
  <HScaffold title="关于我们">
    <div style="display:flex;flex:1;width:100%;flex-direction: column;background-color: white;">
      <div :style='{
        display:"flex",
        alignItems:"flex-end",
        justifyContent:"center",
        paddingBottom:"10%",
        height:"200px",
        backgroundImage:`url(${icon_top_bg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "100% 80%",
        backgroundPosition: "top",
      }'>
        <img :src="icon_logo_domain" style="width:50%" alt="">
      </div>
      <div style="margin-top:10px;display:flex;flex-direction: row;align-items: center;justify-content: center;">
        <div class="gradientLineLeft"/>
        <div :style="hcf.getTextStyle({
          color:'main',marginLeft:10,marginRight:10,
        })">正规牌照
        </div>
        <div class="gradientLineRight"/>
      </div>
      <van-grid :column-num="4" :border="false" style="padding: 0 10px;">
        <van-grid-item v-for="item in allPzInfo" :key="item.text" icon="photo-o">
          <div style="display:flex;flex-direction: column;align-items: center;">
            <img :src="item.icon" style="width:80%;height:1000%;" alt="">
            <div :style="hcf.getTextStyle({
          color:'#888',textAlign:'center',
        })">{{ item.text }}
            </div>
          </div>
        </van-grid-item>
      </van-grid>

      <div :style="hcf.getTextStyle({
          color:'#888',padding:10,textAlign:'center',marginBottom:30,marginTop:20
        })">{{"   我们拥有欧洲马耳他（MGA）、英国GC监督委员会(GamblingCommission)和菲律宾政府(PAGCOR)颁发的合法执照。注册于英属维尔京群岛，是受国际行业协会认可的合法公司。进行注册并娱乐前，请确保您年满18周岁！"}}
      </div>
    </div>
  </HScaffold>
</template>


<script setup>
  import icon_top_bg from '@/assets/icons/my/top_bg.png';
  import icon_jdh from '@/assets/icons/my/jdh.png';
  import icon_wej from '@/assets/icons/my/wej.png';
  import icon_met from '@/assets/icons/my/met.png';
  import icon_flb from '@/assets/icons/my/flb.png';
  import icon_logo_domain from '@/assets/icons/replaces/logo_domain.png';
  import {hcf} from "@/components/utils/HComFunctions.js";

  const allPzInfo = [
    {
      "icon": icon_jdh,
      "text": "英国GC监督\n委员会",
    },
    {
      "icon": icon_wej,
      "text": "英属维尔京\n群岛( BVI ) \n认证",
    },
    {
      "icon": icon_met,
      "text": "马耳他博彩\n牌照( MGA ) \n认证",
    },
    {
      "icon": icon_flb,
      "text": "菲律宾 \n(PAGCOR)\n监管博彩\n执照",
    }
  ];
</script>


<style scoped>
  .gradientLineLeft {
    height: 2px;
    width: 100px;
    border-radius: 10px;
    background: linear-gradient(to right, white, var(--ct-main-color)); /* 替换为 mainColor */
  }

  .gradientLineRight {
    height: 2px;
    width: 100px;
    border-radius: 10px;
    background: linear-gradient(to left, white, var(--ct-main-color)); /* 替换为 mainColor */
  }
</style>
